import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface EmitterEvent<T = any> {
  event?: string;
  value?: T;
  extras?: any;
}

@Injectable()
export class EmitterService {
  private _emitters: { [channel: string]: Subject<EmitterEvent> } = {};

  // @deprecated
  public get(channel: string): Subject<any>;

  public get(channel: string): Subject<EmitterEvent> {
    if (!this._emitters[channel]) {
      this._emitters[channel] = new Subject<EmitterEvent>();
    }
    return this._emitters[channel];
  }
}
